import { useLocation } from "react-router-dom";
import { Phone } from "lucide-react";
import { trackEvent } from "@/lib/track";
import { PHONE_DISPLAY, PHONE_HREF } from "@/lib/contact";

const HIDDEN_ON = ["/admin", "/member", "/payment"];

/** Always-visible tap-to-call button: pill on desktop, full-width bar on mobile. */
export const StickyCallButton = () => {
  const { pathname } = useLocation();
  if (HIDDEN_ON.some((p) => pathname.startsWith(p))) return null;

  return (
    <a
      href={PHONE_HREF}
      onClick={() => trackEvent("phone_call_click", { phone_number: PHONE_DISPLAY, page_path: pathname })}
      aria-label={`Call Tutors Melbourne on ${PHONE_DISPLAY}`}
      data-testid="sticky-call-button"
      className="group fixed z-40 bottom-5 right-4 sm:bottom-6 sm:right-6
                 inline-flex items-center gap-2.5
                 rounded-full bg-brand-purple hover:bg-brand-purple-hover
                 text-white font-body font-semibold
                 pl-3.5 pr-5 py-3 sm:py-3.5
                 shadow-[0_8px_24px_-4px_rgba(107,45,139,0.55)] ring-1 ring-white/15
                 hover:-translate-y-0.5 active:translate-y-0 active:scale-[0.98]
                 transition-[transform,background-color,box-shadow] duration-200
                 mb-[env(safe-area-inset-bottom)]"
    >
      <span className="relative flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-brand-gold">
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-brand-gold/50" />
        <Phone className="relative h-4 w-4" />
      </span>
      <span className="flex flex-col leading-tight text-left">
        <span className="text-[10px] font-normal uppercase tracking-wider text-white/70">Call us</span>
        <span className="text-sm tabular-nums">{PHONE_DISPLAY}</span>
      </span>
    </a>
  );
};

export default StickyCallButton;
